import { Map, ImageOff } from "lucide-react";
import { useState } from "react";
import type { MapSummary } from "../shared/types";
import "./map-library-thumbnail.css";

/** Native lazy images avoid loading documents, logos or GPU contexts per card. */
export function MapLibraryThumbnail({ map }: { map: MapSummary }) {
  const [state, setState] = useState<"loading" | "ready" | "failed">("loading");
  return (
    <div
      className="em-library-thumbnail"
      data-preview-state={state}
      aria-hidden="true"
    >
      {state !== "ready" && (
        <div className="em-library-thumbnail-placeholder">
          {state === "failed" ? <ImageOff size={27} /> : <Map size={27} />}
          <span>
            {state === "failed" ? "Preview unavailable" : "Loading preview…"}
          </span>
        </div>
      )}
      <img
        src={`/api/admin/maps/${encodeURIComponent(map.id)}/thumbnail.svg?revision=${map.revision}`}
        alt=""
        width="512"
        height="320"
        loading="lazy"
        decoding="async"
        onLoad={() => setState("ready")}
        onError={() => setState("failed")}
      />
    </div>
  );
}
